@if (status === 'valid') {
  <svg
    class="valid"
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.59 11.1701L1.42 7.00009L4.74121e-08 8.41009L5.59 14.0001L17.59 2.00009L16.18 0.590088L5.59 11.1701Z"
    />
  </svg>
}

@if (status === 'invalid') {
  <svg
    class="invalid"
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.666626 12.6667H15.3333L7.99996 0L0.666626 12.6667ZM8.66663 10.6667H7.33329V9.33333H8.66663V10.6667ZM8.66663 8H7.33329V5.33333H8.66663V8Z"
    />
  </svg>
}
